const menu = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    translationKey: 'app.navigation.main.dashboard',
    to: '/',
    exact: true,
  },
  {
    key: 'proxies',
    label: 'Proxies',
    translationKey: 'app.navigation.main.proxies',
    to: '/proxies',
    exact: true,
  },
  {
    key: 'divider',
  },
  {
    key: 'documentation',
    label: 'Documentation',
    translationKey: 'app.navigation.main.documentation',
    to: 'https://quicq.io/support/',
    exact: false,
    external: true,
  },
];

export default menu;
